// src/App.js

import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactUsPage from "./pages/ContactUsPage";
import DdikrooCollegeHomepage from "./pages/DdikrooCollegeHomepage";

// import RegisterForm from "./components/RegisterForm";
// import LoginForm from "./components/LoginForm";
// import AdminAccess from "./components/AdminAccess";

import "./styles/App.css";
import "./styles/index.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/college" element={<DdikrooCollegeHomepage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
